<template>
  <div class="service-wall">
    <a-spin :spinning="spinning" tip="数据加载中..." style="min-height: calc(100vh - 352px)">
      <!-- 头部 -->
      <a-row :gutter="16">
        <a-col
          :sm="24"
          :md="12"
          :lg="6"
          v-for="(item, index) in serviceStatistics"
          :key="index"
          style="margin-bottom: 16px"
        >
          <service-count-card
            :title="item.title"
            :count="item.count"
            :icon="item.icon"
            @change="handleChangeStatus(item.key)"
            :style="{
              cursor: 'pointer',
              transition: 'all .3s',
              transform: activeStatus === item.key ? 'translateY(-6px)' : 'translateY(0px)',
              boxShow: activeStatus === item.key ? 'rgb(0 0 0 / 18%) 0px 4px 8px' : 'rgb(0 0 0 / 8%) 0px 0px 8px'
            }"
          ></service-count-card>
        </a-col>
      </a-row>

      <a-tabs v-model="activeTab">
        <reload-button slot="tabBarExtraContent" @click="refresh"></reload-button>
        <a-tab-pane key="overview" tab="总览">
          <a-row v-if="activeServiceData.length" :gutter="16"
            style="background: #fff; padding: 16px 8px 16px; border-radius: 8px; margin: 0;">
            <a-col v-for="service in activeServiceData" :key="service.id" :md="12" :lg="8" :xxl="6"
              style="margin-bottom: 16px">
              <service-card
                :service="service"
                :detailData="serviceDetails[service.id] || {
                  abnormalApplicationCount: 0,
                  serviceAlert: {
                    disaster: 0,
                    high: 0,
                    average: 0,
                    warning: 0
                  },
                  busynessDetail: [],
                  healthDetail: []
                }"
                @ok="refresh"></service-card>
            </a-col>
          </a-row>
          <div v-else-if="!spinning && !activeServiceData.length"
            style="position: relative; overflow: hidden; background: #fff; border-radius: 8px; padding: 80px 0">
            <empty-component :imgUrl="require('@/assets/images/info_empty.png')" :body-style="{
              height: '216px',
              marginTop: '0px'
            }" :description-style="{
              marginTop: '-32px',
              marginRight: '8px'
            }" description="暂无数据"></empty-component>
          </div>
        </a-tab-pane>

        <a-tab-pane v-if="true" key="list" tab="列表详情">
          <a-row :gutter="16"
            style="background: #fff; padding: 8px 8px 16px; border-radius: 8px; margin: 0; min-height: calc(100vh - 352px)">
            <div style="display: flex; padding: 8px 8px 16px 8px; justify-content: space-between">
              <create-button text="创建" v-permission="{ action: 'service.service.create', effect: 'disabled' }"
                @click="$refs.inputDrawer.show()"></create-button>
              <a-input-search class="service-search" placeholder="请输入业务名称" @search="search"></a-input-search>
            </div>
            <service-table :data-source="activeServiceData" :total="activeServiceData.length" :detail-source="serviceDetails" @ok="refresh"></service-table>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-spin>

    <input-drawer ref="inputDrawer" @ok="refresh"></input-drawer>
  </div>
</template>

<script>
import {
  getServiceList,
  getServiceDashboardCount,
  getServiceAlertCount,
  getServiceApplicationList,
  getServiceSourceBusyness,
  getServiceHealth
} from '@/api/service'
import InputDrawer from './modules/InputDrawer.vue'
import ServiceCard from './modules/ServiceCard'
import ServiceCountCard from './modules/ServiceCountCard'
import ServiceTable from './modules/ServiceTable.vue'
import CreateButton from '@/components/button/CreateButton'
import ReloadButton from '@/components/button/ReloadButton'

export default {
  name: 'ServiceDashboardList',
  components: {
    EmptyComponent: () => import('@/components/EmptyComponent.vue'),
    InputDrawer,
    ServiceCard,
    ServiceCountCard,
    ServiceTable,
    CreateButton,
    ReloadButton
  },
  data () {
    return {
      activeStatus: this.$route.params.statusType || 'all',
      activeTab: 'overview',
      searchName: '',
      spinning: false,
      total: 0,
      serviceData: [],
      activeServiceData: [],
      serviceDetails: {},
      serviceStatistics: [
        {
          title: '全部业务数量',
          count: 0,
          icon: 'all',
          key: 'all'
        },
        {
          title: '已建业务数量',
          count: 0,
          icon: 'important',
          key: 'built'
        },
        {
          title: '在建业务数量',
          count: 0,
          icon: 'normal',
          key: 'building'
        },
        {
          title: '拟建业务数量',
          count: 0,
          icon: 'alert',
          key: 'planned'
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.fetchStatisticData()
      await this.fetchDetailData()
    },
    async fetchDetailData () {
      this.spinning = true
      const params = {
        page: 1,
        page_size: 999
      }
      if (this.searchName) {
        params.name = this.searchName
      }
      try {
        const res = await getServiceList(params)
        this.total = res.data?.total || 0
        if (this.total) {
          this.serviceData = res.data.data.sort((a, b) => {
            return a.order - b.order
          })
          if (this.activeStatus !== 'all') {
            this.activeServiceData = this.serviceData.filter(item => item.status === this.activeStatus)
          } else {
            this.activeServiceData = JSON.parse(JSON.stringify(this.serviceData))
          }
          await this.fetchServiceDetails(this.activeServiceData)
        } else {
          this.serviceData = []
          this.activeServiceData = []
          this.serviceDetails = {}
        }
      } catch (error) {
        console.error('Failed to fetch service list:', error)
        this.serviceData = []
        this.activeServiceData = []
        this.serviceDetails = {}
      } finally {
        this.spinning = false
      }
    },
    async fetchStatisticData () {
      const res = await getServiceDashboardCount()
      if (res.data && res.data.data) {
        this.serviceStatistics = this.serviceStatistics.map(item => {
          return {
            ...item,
            count: res.data.data[item.key] || 0
          }
        })
      } else {
        this.serviceStatistics = this.serviceStatistics.map(item => {
          item.count = 0
          return item
        })
      }
    },
    async fetchServiceDetails (services) {
      const newServiceDetails = {}

      const promises = services.map(async (service) => {
        try {
          const [applicationsRes, alertsRes, busynessRes, healthRes] = await Promise.all([
            getServiceApplicationList(service.id),
            getServiceAlertCount(service.id, {
              count_of: 'severity',
              recovered: false
            }),
            getServiceSourceBusyness(service.id),
            getServiceHealth(service.id)
          ])
          const abnormalApplicationCount = applicationsRes.data?.data?.filter(app => app.status !== 'normal').length || 0

          const serviceAlert = {
            disaster: 0,
            high: 0,
            average: 0,
            warning: 0
          }
          if (alertsRes.data?.data) {
            for (const key in serviceAlert) {
              const val = alertsRes.data.data.find(item => item.name === key)?.value || 0
              serviceAlert[key] = val
            }
          }

          const busynessDetail = [
            {
              name: '正常',
              key: 'normal',
              value: busynessRes.data?.normal || 0,
              color: '#51a8f2'
            },
            {
              name: '繁忙',
              key: 'busy',
              value: busynessRes.data?.busy || 0,
              color: '#fa8c16'
            },
            {
              name: '空闲',
              key: 'idle',
              value: busynessRes.data?.idle || 0,
              color: '#43b94d'
            }
          ]

          const healthDetail = healthRes.data?.statistic || []
          newServiceDetails[service.id] = {
            abnormalApplicationCount,
            serviceAlert,
            busynessDetail,
            healthDetail
          }
        } catch (error) {
          console.error(`Failed to fetch details for service ${service.id}:`, error)
          newServiceDetails[service.id] = {
            abnormalApplicationCount: 0,
            serviceAlert: {
              disaster: 0,
              high: 0,
              average: 0,
              warning: 0
            },
            busynessDetail: [
              { name: '正常', key: 'normal', value: 0, color: '#51a8f2' },
              { name: '繁忙', key: 'busy', value: 0, color: '#fa8c16' },
              { name: '空闲', key: 'idle', value: 0, color: '#43b94d' }
            ],
            healthDetail: []
          }
        }
      })

      await Promise.all(promises)
      this.serviceDetails = newServiceDetails
    },
    async handleChangeStatus (status) {
      if (this.activeStatus === status) {
        return
      }
      this.spinning = true
      this.activeStatus = status
      if (this.activeStatus !== 'all') {
        this.activeServiceData = this.serviceData.filter(item => item.status === this.activeStatus)
      } else {
        this.activeServiceData = JSON.parse(JSON.stringify(this.serviceData))
      }
      const servicesNeedDetails = this.activeServiceData.filter(
        service => !this.serviceDetails[service.id]
      )
      if (servicesNeedDetails.length > 0) {
        await this.fetchServiceDetails(servicesNeedDetails)
      }
      this.spinning = false
    },
    async refresh () {
      this.spinning = true
      this.serviceDetails = {}
      this.fetchStatisticData()
      const params = {
        page: 1,
        page_size: 999
      }
      if (this.searchName) {
        params.name = this.searchName
      }
      try {
        const res = await getServiceList(params)
        this.total = res.data?.total || 0
        if (this.total) {
          this.serviceData = res.data.data.sort((a, b) => {
            return a.order - b.order
          })
          await this.fetchServiceDetails(this.serviceData)
          if (this.activeStatus !== 'all') {
            this.activeServiceData = this.serviceData.filter(item => item.status === this.activeStatus)
          } else {
            this.activeServiceData = JSON.parse(JSON.stringify(this.serviceData))
          }
        } else {
          this.serviceData = []
          this.activeServiceData = []
          this.serviceDetails = {}
        }
      } catch (error) {
        console.error('Failed to fetch service list:', error)
        this.serviceData = []
        this.activeServiceData = []
        this.serviceDetails = {}
      } finally {
        this.spinning = false
      }
    },
    async search (value) {
      if (this.searchName === value) {
        return
      }
      this.searchName = value
      await this.fetchDetailData()
    },
    async reset () {
      if (!this.searchName) {
        return
      }
      this.searchName = ''
      await this.fetchDetailData()
    }
  }
}
</script>

<style lang="less">
.service-wall {
  .ant-tabs-bar {
    padding: 0 0 0 14px;
    margin-top: -12px;
  }

  .service-search {
    width: 180px;

    .ant-input {
      background-color: #fff;
    }
  }

  .ant-collapse-borderless {
    background: transparent;

    &>.ant-collapse-item {
      box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;

      .collapse-title {
        padding-left: 24px;
        position: relative;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        height: 22px;
        line-height: 22px;

        &::before {
          content: '';
          position: absolute;
          width: 4px;
          height: 20px;
          top: 1px;
          left: 10px;
          background: #096dd9;
          border-radius: 2px;
        }

        .collapse-icon {
          color: #5e98e3;
          font-size: 12px;
          vertical-align: middle;
          margin: 0 0 3px 8px;
        }
      }
    }
  }
}
</style>
